export function capitalize(str: string | null): string {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getPathParts(path: string | null): string[] {
  if (!path) {
    return [];
  }
  return path.split('/').filter((part) => part);
}